import { render, staticRenderFns } from "./combobox.vue?vue&type=template&id=8f3a2fa4"
import script from "./combobox.vue?vue&type=script&lang=js"
export * from "./combobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports